module.exports = __webpack_public_path__ + "static/img/__8282.fd917ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__8282.jpg
// module id = uWb6
// module chunks = 0